"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.REVERSE_LEVEL_LOOKUP = exports.ALL_LEVELS = exports.LOGGABLE_LEVELS = exports.LEVEL_TRACE = exports.LEVEL_DEBUG = exports.LEVEL_INFO = exports.LEVEL_WARN = exports.LEVEL_ERROR = exports.LEVEL_FATAL = exports.LEVEL_DISABLED = exports.toLog = void 0;
exports.toLog = Symbol.for('@codegrade/logging::toLog');
exports.LEVEL_DISABLED = 80;
exports.LEVEL_FATAL = 60;
exports.LEVEL_ERROR = 50;
exports.LEVEL_WARN = 40;
exports.LEVEL_INFO = 30;
exports.LEVEL_DEBUG = 20;
exports.LEVEL_TRACE = 10;
exports.LOGGABLE_LEVELS = [
    exports.LEVEL_FATAL,
    exports.LEVEL_ERROR,
    exports.LEVEL_WARN,
    exports.LEVEL_INFO,
    exports.LEVEL_DEBUG,
    exports.LEVEL_TRACE,
];
exports.ALL_LEVELS = [exports.LEVEL_DISABLED, ...exports.LOGGABLE_LEVELS];
exports.REVERSE_LEVEL_LOOKUP = Object.freeze({
    disabled: exports.LEVEL_DISABLED,
    fatal: exports.LEVEL_FATAL,
    error: exports.LEVEL_ERROR,
    warn: exports.LEVEL_WARN,
    info: exports.LEVEL_INFO,
    debug: exports.LEVEL_DEBUG,
    trace: exports.LEVEL_TRACE,
});
